import { useRef } from 'react'
import { useEffectReducer } from 'use-effect-reducer'
import {
  INTEGRATION_TYPE,
  TerminalEventMonitoring,
} from '@lightspeed-payments/payments-terminal-sdk'
import { useVdFeatureManager } from '../../../../../ng-compat/hooks'
import { SANDBOX_FLAG } from '../../helpers/lspayConstants'
import { getMonitoringInstance } from '../../helpers/terminalMonitoring'
import { getPMOFEffectsMap } from './effects'
import { pmofStateReducer } from './reducer'
import { PMOFArgs, PMOFState } from './types'

export const usePMOFEffectReducer = (args: PMOFArgs) => {
  const isSandbox = useVdFeatureManager().get(SANDBOX_FLAG)
  const terminalMonitoringInstanceRef = useRef<TerminalEventMonitoring | null>(
    null
  )
  if (!terminalMonitoringInstanceRef.current) {
    terminalMonitoringInstanceRef.current = getMonitoringInstance(
      args.outletId,
      isSandbox,
      INTEGRATION_TYPE.SAVED_PAYMENT_METHOD
    )
  }

  return useEffectReducer(
    pmofStateReducer,
    exec => {
      if (args.customerId && args.paymentMethodOnFileId) {
        exec({ type: 'processPaymentEffect' })
      }
      return { status: 'processing' } as PMOFState
    },
    getPMOFEffectsMap({
      ...args,
      terminalMonitoringInstance: terminalMonitoringInstanceRef.current,
    })
  )
}
